import { ActivityReservationInternalModel, ConnectionInfo, ConnectionMode, ReservationMethod } from "Services/API/API";
import { User } from "../../type";
import { ActivitiesType } from "./type";

export const filterByCountry = (
   activity: ActivityReservationInternalModel,
   country: string
): boolean => {
   return activity.country === country;
};

export const filterByState = (
   activity: ActivityReservationInternalModel,
   state?: string
): boolean => {
   return !state || state === activity.state;
};

export const filterByUsers = (
   activity: ActivityReservationInternalModel,
   users: User[]
): boolean => {
   return !users.length || users.some((user) => activity.memberId === user.id);
};

export const filterByType = (
   activity: ActivityReservationInternalModel,
   type: ActivitiesType,
   userId: string,
   connections: ConnectionInfo[]
): boolean => {
   if(type === ActivitiesType.MY) {
      return activity.memberId === userId;
   }
   if(type === ActivitiesType.FOLLOWING) {
      const connection = connections.find(c => c.targetId == activity.memberId);
      return !!connection && connection.connectionMode == ConnectionMode.Following;
   }
   return true;
};

export const filterByReservationMethod = (activity: ActivityReservationInternalModel): boolean => {
   if(activity.reservationType == ReservationMethod.Monthly)
      return false;

   return true;
}